// Small helper to resolve asset URLs (avatars, logos, uploaded files, etc.) to an
// absolute URL that always hits the backend, regardless of whether the backend is
// stored as a relative path (e.g. "/api/uploads/xxx.png") or full URL.
//
// Why this exists:
//   * The frontend and backend are on DIFFERENT origins in the preview environment
//     (frontend at inquiry-filters..., backend at 16f07de4...). A bare
//     `/api/uploads/xxx.png` inside an <img src> would resolve against the frontend
//     origin and 404. In production both live under the same domain, so raw paths
//     happen to work — masking the bug in dev and breaking it in preview.
//   * This helper prefixes REACT_APP_BACKEND_URL for any relative path and leaves
//     absolute URLs (http/https/data:) untouched.

const BACKEND = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

export function resolveAsset(url) {
  if (!url) return undefined;
  const s = String(url).trim();
  if (!s) return undefined;
  if (/^(https?:|data:|blob:)/i.test(s)) return s;
  // Relative path — prefix backend URL. Handle both "/foo" and "foo" forms.
  return `${BACKEND}${s.startsWith("/") ? "" : "/"}${s}`;
}

// Small onError handler for <img>: hide the broken image so the fallback (usually
// an <AvatarFallback> or a text initial) becomes visible instead of the browser's
// default broken-image glyph. Usage: `onError={hideOnError}`.
export function hideOnError(e) {
  try {
    e.currentTarget.style.display = "none";
    // Radix Avatar hides the image after load errors when we set src to empty too.
    e.currentTarget.src = "";
  } catch { /* noop */ }
}
